<template>
  <v-container fluid>
    <v-dialog
      :value="!valid"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-form ref="form" v-model="formValid" @submit.prevent="">
        <v-card class="pa-1">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                autofocus
                v-model="id"
                label="病歷號"
                :rules="[(v) => !!v || '請輸入病歷號']"
                hint="請輸入病歷號"
                type="number"
                outlined
                persistent-hint
                append-outer-icon="mdi-arrow-right"
                @click:append-outer="checkIsValid"
                @keyup.enter="checkIsValid"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-dialog>

    <v-card flat v-if="valid" height="81vh">
      <questionnaire :patient-id="patientId" />
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
    Questionnaire: () => import("../components/Questionnaire.vue"),
  },
  data: () => ({
    formValid: false,
    valid: false,
    id: null,
  }),

  computed: {
    patientId() {
      return parseInt(this.id === null ? this.$route.params.id : this.id);
    },
  },

  methods: {
    checkIsValid() {
      if (!this.$refs.form.validate()) return;
      this.valid = true;
    },
  },

  mounted() {
    if (
      this.patientId !== null &&
      this.patientId !== undefined &&
      !isNaN(this.patientId)
    )
      this.valid = true;
  },
};
</script>
